import LegacyAccountDetailsModal from '../../../banking/components/spaces/LegacyAccountDetailsModal';

const AccountDetails = () => {
    return <LegacyAccountDetailsModal />;
};

export default AccountDetails;
